import { render, staticRenderFns } from "./TutorialSidebar.vue?vue&type=template&id=fdbce2e4&scoped=true&"
import script from "./TutorialSidebar.vue?vue&type=script&lang=js&"
export * from "./TutorialSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TutorialSidebar.vue?vue&type=style&index=0&id=fdbce2e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbce2e4",
  null
  
)

export default component.exports